import React, { Suspense } from 'react'

const Loadable = (Component) => {
  return function LoadableComponent(props) {
    return (
      <Suspense fallback={ 
      <div className="preloader ">
         <div className="preloader-inner">
            <img src="/assest/img/logo-black.png" alt="Vega Studio" />
            <span className="loader style3"></span>
         </div>
      </div> }>
        <Component {...props} />
      </Suspense>
    )
  }
}

export default Loadable